import { createSelector } from 'reselect';
import { hasActiveSearchBarSelector } from '@xingternal/platform-layout-selectors';
const loggedInSubHeaderSelector = createSelector(hasActiveSearchBarSelector, (hasActiveSearchBar) => ({
    hasActiveSearchBar,
}));
export { loggedInSubHeaderSelector };
//# sourceMappingURL=LoggedInSubHeader.selectors.js.map